// noinspection CssUnusedSymbol

import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import svg from './arrow.svg';

export const Breadcrumb = styled(Link)`
  display: flex;
  color: ${({ theme }) => theme.colors.DarkBlue};
  font-family: 'SF Pro Text', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.DarkYellow};
  }

  &:not(:last-child) {
    &::after {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(${svg}) no-repeat center / contain;
      margin: 0 8px;
      position: relative;
      top: 2px;
    }
  }

  &.active {
    pointer-events: none;
    color: ${({ theme }) => theme.colors.DarkBlue};
    font-weight: 600;
  }
`;
